import React from 'react'

import { SingleBarChart } from 'nswidgets/src/components/bar/bar'
import { Tooltip } from 'nswidgets/src/common/tooltip/tooltip'
import { TooltipContextProvider } from 'nswidgets/src/common/tooltip/tooltip.context'

export const BarBlockChart = function (props = {}) {
  return (
    <TooltipContextProvider>
      <SingleBarChart {...props} />
      <Tooltip />
    </TooltipContextProvider>
  )
}
